import { sanitizeAlgoliaQueryId } from '~/utils/helpers'
import { getEventListIndexName } from '~/utils/algoliaHelpers'

interface algoliaEventProps {
  objectID: string
  position: number
  algoliaInsightsClient: any
  label: string
  queryId: string
  locale: string
  userToken: string
  /** When set (e.g. kits from products_*), click insights use this index instead of events_*. */
  indexName?: string
}

export const useSendEventToAlgolia = ({
  objectID,
  position,
  algoliaInsightsClient,
  label,
  queryId,
  locale,
  userToken,
  indexName,
}: algoliaEventProps) => {
  if (
    !window?.localStorage ||
    algoliaInsightsClient === null ||
    algoliaInsightsClient === undefined ||
    typeof algoliaInsightsClient !== 'function' ||
    !userToken
  )
    return

  // Sanitize and validate queryId
  const sanitizedQueryId = sanitizeAlgoliaQueryId(queryId)

  // Use AfterSearch variant only when queryId is valid
  const algoliaInsightsMethod = sanitizedQueryId
    ? 'clickedObjectIDsAfterSearch'
    : 'clickedObjectIDs'

  const payload: any = {
    userToken,
    index: indexName || getEventListIndexName(locale),
    eventName: 'Event Clicked - ' + label,
    objectIDs: [objectID],
  }

  // Only include queryId and positions when queryId is valid
  // positions are only meaningful in the context of a search query
  if (sanitizedQueryId) {
    payload.queryId = sanitizedQueryId
    payload.positions = [position]
  }

  algoliaInsightsClient(algoliaInsightsMethod, payload)
}
